import { SessionChange, MagicConfigMixin, ModalMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Emit, Component, Mixins } from 'vue-property-decorator';
import { AML_STATUS_UPDATED, USER_JURISDICTION_QUERY, AML_STATUS_QUERY, GRACE_PERIOD_QUERY, USER_SET_REQUIRES_SOW } from '@gig/magic-messages';
import { importResponsibleGaming } from '../../utils/helpers.js';
import { shouldDisplayLinkToWithdraw, getGracePeriodDaysLeft, isKYCRequestedByAML } from '@gig/magic-jurisdictions';
import { AmlStatus } from '@gig/magic-sdk/dist/adapter/users/getAmlStatus';

/**
 * Prompts a modal explaining days left until a user
 * needs to provide their documentation.
 */
var SowPrompterComponent = /** @class */ (function (_super) {
    __extends(SowPrompterComponent, _super);
    function SowPrompterComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.periods = [];
        _this.amlStatus = null;
        _this.amlStatusSubscription = null;
        _this.alreadyShown = false;
        return _this;
    }
    SowPrompterComponent.prototype.created = function () {
        var _this = this;
        this.amlStatusSubscription = window.eventBus.subscribe(AML_STATUS_UPDATED, function () {
            _this.fetchAmlAndGracePeriodStatus();
        }, { replay: true });
    };
    SowPrompterComponent.prototype.destroyed = function () {
        var _a;
        (_a = this.amlStatusSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    };
    SowPrompterComponent.prototype.onSessionChange = function (isLoggedIn) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!isLoggedIn) {
                    this.closeModal();
                    this.alreadyShown = false;
                    this.actionRequired(false);
                    return [2 /*return*/];
                }
                return [2 /*return*/];
            });
        });
    };
    SowPrompterComponent.prototype.updateGracePeriodState = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var daysLeft, status, isRequiredToPrompt, countdownModal, jurisdiction, dismissible;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        daysLeft = getGracePeriodDaysLeft(this.periods);
                        status = (_b = (_a = this.amlStatus) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : {
                            SOWQ: AmlStatus.NOT_SET,
                            SOWD: AmlStatus.NOT_SET,
                        };
                        isRequiredToPrompt = !!daysLeft || isKYCRequestedByAML(status);
                        if (!isRequiredToPrompt) {
                            this.actionRequired(false);
                            return [2 /*return*/];
                        }
                        if (this.alreadyShown) {
                            return [2 /*return*/];
                        }
                        if (!this.shouldHide) return [3 /*break*/, 1];
                        this.closeModal();
                        return [3 /*break*/, 4];
                    case 1: return [4 /*yield*/, importResponsibleGaming()];
                    case 2:
                        _c.sent();
                        countdownModal = document.createElement(this.renderedModal);
                        countdownModal.daysLeft = daysLeft;
                        return [4 /*yield*/, window.queryBus.query(USER_JURISDICTION_QUERY)];
                    case 3:
                        jurisdiction = _c.sent();
                        countdownModal.displayWithdrawLink = shouldDisplayLinkToWithdraw(jurisdiction, daysLeft).toString();
                        dismissible = daysLeft > 0;
                        this.openModal(countdownModal, this.header, {
                            dismissible: dismissible,
                            keepAfterClear: !dismissible,
                            onClose: function () {
                                if (!_this.shouldHide) {
                                    _this.alreadyShown = true;
                                }
                            },
                        });
                        _c.label = 4;
                    case 4:
                        this.actionRequired(true, daysLeft);
                        return [2 /*return*/];
                }
            });
        });
    };
    SowPrompterComponent.prototype.fetchAmlAndGracePeriodStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, amlStatus, periods;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            window.queryBus.query(AML_STATUS_QUERY),
                            window.queryBus.query(GRACE_PERIOD_QUERY),
                        ])];
                    case 1:
                        _a = _b.sent(), amlStatus = _a[0], periods = _a[1];
                        this.amlStatus = amlStatus;
                        this.periods = periods;
                        this.updateGracePeriodState();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Emits once the current SOW status has been determined
     * @param isActionRequired
     */
    SowPrompterComponent.prototype.actionRequired = function (isActionRequired, daysRemaining) {
        window.commandBus.publish(USER_SET_REQUIRES_SOW, {
            isActionRequired: isActionRequired,
            daysRemaining: daysRemaining,
        });
        return { isActionRequired: isActionRequired, daysRemaining: daysRemaining };
    };
    SowPrompterComponent.prototype.render = function () {
        return null;
    };
    SowPrompterComponent.prototype.isRequired = function () {
        return [];
    };
    __decorate([
        Prop({
            type: String,
            default: 'magic-sow-countdown-prompt',
        }),
        __metadata("design:type", String)
    ], SowPrompterComponent.prototype, "renderedModal", void 0);
    __decorate([
        Prop({
            type: String,
            default: 'sow-countdown-prompt.header',
        }),
        __metadata("design:type", Object)
    ], SowPrompterComponent.prototype, "header", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], SowPrompterComponent.prototype, "shouldHide", void 0);
    __decorate([
        SessionChange({ immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", Promise)
    ], SowPrompterComponent.prototype, "onSessionChange", null);
    __decorate([
        Watch('shouldHide'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], SowPrompterComponent.prototype, "updateGracePeriodState", null);
    __decorate([
        Emit('action-required'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean, Number]),
        __metadata("design:returntype", void 0)
    ], SowPrompterComponent.prototype, "actionRequired", null);
    SowPrompterComponent = __decorate([
        Component({
            name: 'sow-prompter',
        })
    ], SowPrompterComponent);
    return SowPrompterComponent;
}(Mixins(MagicConfigMixin, ModalMixin)));

export { SowPrompterComponent };
